import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(
    value: any[],
    filterString: string,
    propName: string
  ): any[] {

    if (!value || value.length === 0 || !filterString || !propName) {
      return value;
    }

    const result = [];

    for (const item of value) {

      const fieldValue = item[propName] ?? '';

      if (
        fieldValue
          .toString()
          .toLowerCase()
          .includes(filterString.toLowerCase())
      ) {
        result.push(item);
      }
    }

    return result;
  }
}